import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Colors, Fonts } from '../../Utils/theme'

const useStyles = makeStyles((theme) => ({
  leftIcon: {
    marginRight: '0.5rem'
  },
  rightIcon: {
    marginLeft: '0.5rem'
  },
  centerIcon: {
    margin: 0
  },
  baseButton: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: 60,
    borderRadius: 5,
    alignItems: 'center',
    textTransform: 'none',
    [theme.breakpoints.down('lg')]: {
      height: 50
    },
    [theme.breakpoints.down('md')]: {
      height: 45,
    }
  },
  baseButtonText: {
    margin: 0,
    fontFamily: Fonts.content,
    fontSize: '1.25rem',
    fontWeight: 700,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1rem'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.875rem'
    }
  },

  // Button variants
  defaultButton: {
    backgroundColor: Colors.primaryButtonColor,
    '&:hover': {
      backgroundColor: Colors.primaryButtonHoverColor
    },
  },
  defaultButtonText: {
    color: Colors.white
  },
  secondaryButton: {
    backgroundColor: 'transparent',
    border: `1px solid ${Colors.secondaryButtonColor}`,
    '&:hover': {
      backgroundColor: 'transparent',
      border: `1px solid ${Colors.secondaryButtonHoverColor}`
    }
  },
  secondaryButtonText: {
    color: Colors.secondaryButtonColor
  },
  smallButton: {
    padding: '0.75rem',
    height: '2.25rem',
  },
  smallButtonText: {
    fontSize: '0.75rem',
    whiteSpace: 'nowrap'
  },
  disabledButton: {
    opacity: 0.4
  },
  marginButton: {
    margin: '1rem 0'
  },

  fullWidthButton: {
    width: '100%',
    boxSizing: 'border-box'
  },

  // Loading icon variants
  colorWhite: {
    color: 'white'
  },
  colorBlack: {
    color: 'black'
  }
}))

export default function BaseButton(props) {
  const classes = useStyles()

  const buttonClasses = [classes.baseButton]
  const buttonTextClasses = [classes.baseButtonText]
  let loadingClass = classes.colorWhite
  let loadingSize = 22

  // Add button base style
  if (props.secondary) {
    loadingClass = classes.colorBlack
    buttonClasses.push(classes.secondaryButton)
    buttonTextClasses.push(classes.secondaryButtonText)
  } else {
    buttonClasses.push(classes.defaultButton)
    buttonTextClasses.push(classes.defaultButtonText)
  }

  // Add size
  if (props.small) {
    loadingSize = 18
    buttonClasses.push(classes.smallButton)
    buttonTextClasses.push(classes.smallButtonText)
  }

  // Add width
  if (props.fullWidth) {
    buttonClasses.push(classes.fullWidthButton)
  }

  // Add margin
  if (props.margin) {
    buttonClasses.push(classes.marginButton)
  }

  // Add additional classes
  if (props.buttonStyle) {
    buttonClasses.push(props.buttonStyle)
  }
  if (props.textStyle) {
    buttonTextClasses.push(props.textStyle)
  }

  const renderContent = () => {
    if (props.loading) return <CircularProgress className={loadingClass} size={loadingSize} />

    if (props.icon) return  <img src={props.icon} className={classes.centerIcon} alt='icon' />
    return (
      <>
        {props.leftIcon && <img src={props.leftIcon} className={classes.leftIcon} alt='icon' />}
        <p className={buttonTextClasses.join(' ')}>
          {props.text}
        </p>
        {props.rightIcon && <img src={props.rightIcon} className={classes.rightIcon} alt='icon' />}
      </>
    )
  }

  return (
    <Button
      className={buttonClasses.join(' ')}
      onClick={props.onClick}
      disabled={props.disabled}
      classes={{ disabled: classes.disabledButton }}
    >
      {renderContent()}
    </Button>
  )
}
